import React from 'react';
import { CardHeader } from '@europrocurement/flexy-components';

const DossierDocumentsSignHeading: React.FunctionComponent = function () {
    return (
        <CardHeader
            title="Dossiers de signature électronique"
            headerSx={{
                paddingX: 0,
                paddingY: '1em',
            }}
        />
    );
};

export default DossierDocumentsSignHeading;
